import React from "react";
import * as aserver from '../../APIClient';
import { Button } from "@material-ui/core";
import PayPal from './payPal';
import AephoriaLogo from "../images/Aephoria-logo-blue-login.png"
const axios = require('axios');

const modeRegister = 'register';
const modePostPayment = 'postpayment';
const pfItemName = "Aephoria Enneagram Assessment";
const pfItemDescription = "The Aephoria Enneagram Self-registered Assessment."

const providerPayFast = 'PayFast';
const providerPayPal = 'PayPal';

const negegesigteRegisterUUID = '88ca1750-106a-451f-bd27-d2ec54bc0236';
const afrikaans = 'afrikaans';
const english = 'english';


function requiredLanguageOfUI() {
  let language=english;
  if (window.location.href.includes('/register/')) {
    // the /negegesigte and /chainstochoices shortcuts both redirect here (same coach, same page)
    // but want different starting languages, so they're distinguished via a ?lang= override;
    // without one (i.e. the plain coach register link was used directly), this coach defaults to Afrikaans.
    let queryLanguage = new URLSearchParams(window.location.search).get('lang');
    if (queryLanguage===afrikaans || queryLanguage===english)
      language = queryLanguage
    else if (window.location.href.includes(negegesigteRegisterUUID))
      language = afrikaans
    setLocalStorageValue('uiLanguage',language)
  } else {
    language = getLocalStorageValue('uiLanguage',english);
  }
  return(language)
}

function getLocalStorageValue(field, defaultValue) {
  return(localStorage.getItem('selfregister_'+field)??(defaultValue??''));
}

function setLocalStorageValue(field, value) {
  localStorage.setItem('selfregister_'+field, value);
}

function setCheckoutSpecificField(field, value) {
  localStorage.setItem(`selfregister_${field}_${localStorage.getItem('checkoutId')}`, value);
}

function getCheckoutSpecificField(field) {
  return(localStorage.getItem(`selfregister_${field}_${localStorage.getItem('checkoutId')}`));
}

class SelfRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      // register:
      name: getLocalStorageValue('name'),
      surname: getLocalStorageValue('surname'),
      email: getLocalStorageValue('email'),
      registerUUID: '',
      assessmentType: 'ennea',
      assessmentLanguage: requiredLanguageOfUI(),
      costOfAssessment: '',
      currency: '',
      checkoutId: "",
      provider: null,
      buttonClicked: false,
      message: "",
      coachValid: null,
      priceString: "",
      negegesigte: false,
      isFree: false,
      freeRegistrationComplete: false,
      proceeding: false,
      // postpayment:
      isPaymentComplete: null,
      assessmentLink: "",
      bodyText: "",
      referenceNumber: "",
      response: null,
      hideCoachBlurb: false,
      error: null,
      paypalCaptureUrl: "/selfpay/paypalcapture"
    };
  }

  async componentDidMount() {
    if (this.state.mode === modeRegister)
      this.initializeRegisterMode();
    if (this.state.mode === modePostPayment)
      this.initializePostPaymentMode();
  }

  btranslate(message, ...params) {
    let result = message;
    if (this.state.uiLanguage===afrikaans) {
      if (message == 'Individual Enneagram Assessment Registration')
      message = 'Assessment Registration'
      let translation = this.state.translations?.afrikaans[message];
      if (!translation)
        result = '@'+message+'@';
      else
        result = translation;
    }
    let index = 0;
    return result.replace(/\{.*?\}/g, () => {
      const replacement = params[index++];
      return replacement !== undefined ? replacement : "";
    });    
  }  

  btranslateLink(message, delim, href, blank) {
    message = this.btranslate(message);
    const bits = message.split(delim);
    return <>
      {bits[0]}
      <a href={href} target={blank?"_blank":"_self"}>
        {bits[1]}
      </a>
      {bits[2]}
    </>
  }

  async initializeRegisterMode() {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    const registerUUID = parts[parts.length - 1];
    const coachValid = registerUUID.length === 36;
    this.setState({ registerUUID });
    this.setState({ coachValid: coachValid })
    if (!coachValid)
      return;
    let init;
    try {
      init = await axios.get(`${aserver.getServerRoot()}/selfpay/init/${registerUUID}`);
    } catch (err) {
      this.setState({ coachValid: false })
      return;
    }
    const hideCoachBlurb = [
      '113ca761-2125-4dc2-b3a5-314209d1a325', // Professional Pairs Self-register
      '05856ddf-ed04-30d7-3fb0-496cc8ad75a5', // Aephoria Self-Register Coach
      'c854870f-3cc3-4780-a96c-cc1fa03c8b3d', // Aephoria Promotions
    ].includes(registerUUID);
    this.setState({ registerUUID, hideCoachBlurb: hideCoachBlurb });

    const root = aserver.getServerRoot(true);
    let sroot = root;
    if ((root.includes('3100'))||(root.includes('3000')))
      sroot = init.data.selfpayroot;
    this.setState({uiLanguage: requiredLanguageOfUI()});
    setLocalStorageValue('translations', JSON.stringify(init.data.translations));
    this.setState({
      return_url: `${root}/coachportal/paymentstatus`,
      cancel_url: `${root}/coachportal/paymentstatus`,
      notify_url: `${sroot}/selfpay/receive_notification/`,
      currency: init.data.currency,
      translations: init.data.translations,
      coachName: init.data.coachName,
      priceString: init.data.priceString, //btranslatex('R{cost} including VAT (ZAR)')
      costOfAssessment: init.data.costOfAssessment,
      costOfAssessmentNormal: init.data.costOfAssessmentNormal,
      negegesigte: init.data.negegesigte,
      isFree: init.data.isFree,
      formAction: `https://${init.data.payFastHost}/eng/process`,
      payFastMerchantId: init.data.payFastMerchantId,
      payPalClientId: init.data.payPalClientId,
      payPalEnvironment: init.data.payPalEnvironment
    })
  }

  async initializePostPaymentMode() {
    const checkoutId = localStorage.getItem("checkoutId");
    const registerUUID = localStorage.getItem("registerUUID");
    this.setState({
      checkoutId: checkoutId,
      registerUUID: registerUUID,
      uiLanguage: requiredLanguageOfUI(),
      translations: JSON.parse(getLocalStorageValue('translations', JSON.stringify({})))
    })
    let previousPaymentState = localStorage.getItem(`paymentTransasction_${checkoutId}`)
    const paymentData = JSON.parse(localStorage.getItem(`paymentData_${checkoutId}`));
    if (previousPaymentState !== "pending") {
      this.setState(paymentData);
    } else {
      this.testPaymentStatus(checkoutId);
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    })
    if (name === 'assessmentLanguage' && this.state.negegesigte) {
      this.setUILanguage(value);
    }    
  };

  setUILanguage = (language) => {
    setLocalStorageValue('uiLanguage', language);
    setLocalStorageValue('assessmentLanguage', language);
    this.setState({ uiLanguage: language, assessmentLanguage: language });
  }

  onPayPalFailure = (failureType, message, data) => {
    setCheckoutSpecificField('failureMessage', message);
    this.redirectToPaymentStatus();
  }

  onPayPalSuccess = (checkOutId) => {
    this.redirectToPaymentStatus();
  }

  redirectToPaymentStatus = () => {
    this.setState({
      redirecting: true
    })
    aserver.goto('/coachportal/paymentstatus');      
  }

  proceedToPaymentGateway = async () => {
    const { name, surname, email, assessmentType, registerUUID, assessmentLanguage, costOfAssessment, currency, priceString, isFree } = this.state;
    const provider = (currency==='ZAR'?providerPayFast:providerPayPal);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isEmailValid = emailRegex.test(email);
    let areDetailsFilled = email && name && surname && assessmentType
    if (!areDetailsFilled) {
      alert(this.btranslate('Please provide all details.'))
      return;
    }
    if (!isEmailValid) {
      alert(this.btranslate('Please provide a valid email address.'));
      return;
    }
    setLocalStorageValue('name', name);
    setLocalStorageValue('surname', surname);
    setLocalStorageValue('email', email);
    setLocalStorageValue('assessmentLanguage', assessmentLanguage)
    try {
      this.setState({
        buttonClicked: true,
        proceeding: !isFree && provider===providerPayFast,
      })
      let checkout = await axios.post(`${aserver.getServerRoot()}/selfpay/checkout`, {
        name: name,
        surname: surname,
        email: email,
        provider: provider,
        providerIsPayPal: provider===providerPayPal,
        amount: costOfAssessment,
        currency: currency,
        assessmentType: assessmentType,
        assessmentLanguage: assessmentLanguage,
        registerUUID: registerUUID,
      })
      if (isFree && checkout.status === 200) {
        await axios.get(`${aserver.getServerRoot()}/selfpay/checkpayment/${checkout.data.checkoutId}`);
        this.setState({ freeRegistrationComplete: true, proceeding: true, buttonClicked: false });
        return;
      }
      if (checkout.status === 200) {
        this.setState({
          checkoutId: checkout.data.checkoutId,
          provider: provider,
          proceeding: true,
          showPayPalButtons: provider === providerPayPal,
          message: <>
            {(provider===providerPayFast)&&<p>
              {this.btranslate('Please wait, redirecting to PayFast.')}
            </p>}
            <p>
              {this.btranslate('You will be paying for an Enneagram assessment in {language} for {price}', 
                aserver.LanguageMap[assessmentLanguage], 
                this.btranslate(priceString, costOfAssessment))}.
            </p>
            {(provider===providerPayPal)&&<p>
              {this.btranslate('Please click on the PayPal button to start the payment process.')}
            </p>}
          </>
        });
        localStorage.setItem("checkoutId", checkout.data.checkoutId)
        localStorage.setItem("registerUUID", registerUUID)
        localStorage.setItem(`paymentTransasction_${checkout.data.checkoutId}`, "pending")
      } else {
        this.setState({ message: checkout.data.error, proceeding: true, buttonClicked: false })
      }
    } catch (err) {
      this.setState({
        message: err.response?.data?.error?.description || "An error occurred. Please try again.",
        proceeding: true,
        buttonClicked: false,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.mode === modeRegister) {
      if (this.state.checkoutId && prevState.checkoutId !== this.state.checkoutId) {
        if (this.state.provider === providerPayFast) {
          document.PayFastPayNowForm.submit();
        }
      }
    }
  }

  testPaymentStatus = async (checkoutId) => {
    if (!checkoutId)
      checkoutId = this.state.checkoutId;
    try {
      let response = await axios.get(`${aserver.getServerRoot()}/selfpay/checkpayment/${checkoutId}`);
      let checkStatus = response.data;
      let status = '';
      let paymentData = {};
      if (checkStatus.success) {
        paymentData = {
          isPaymentComplete: checkStatus.success,
          name: checkStatus.name,
          surname: checkStatus.surname,
          email: checkStatus.email,
          priceString: checkStatus.priceString,
          cost: checkStatus.cost,
          assessmentType: checkStatus.assessmentType,
          assessmentLanguage: checkStatus.assessmentLanguage,
        };
        status = 'success';
      } else if (checkStatus.pending) {
        paymentData = {
          bodyText: "Please wait, still checking.",
        };
        status = 'pending';
        setTimeout(this.testPaymentStatus, 30000);
      } else {
        paymentData = {
          bodyText: checkStatus.paymentNotes,
          failureMessage: getCheckoutSpecificField('failureMessage')
        };
        status = 'fail';
      }
      paymentData.referenceNumber = checkStatus.referenceNumber;
      paymentData.registerUUID = this.state.registerUUID;
      this.setState(paymentData);
      localStorage.setItem(`paymentData_${checkoutId}`, JSON.stringify(paymentData));
      localStorage.setItem(`paymentTransasction_${checkoutId}`, status)
    } catch (err) {
      this.setState({ 
        bodyText: err.toString(),
        registerUUID: this.state.registerUUID
      });
    }
  };

  render() {
    let showBody = <></>

    if (this.state.mode === modePostPayment) {
      const { name, surname, priceString, cost, email, assessmentLanguage, assessmentType, bodyText, referenceNumber, failureMessage } = this.state;
      showBody = <div>
        <p>
        {!this.state.isPaymentComplete&&<>
          {failureMessage&&<p>{failureMessage}</p>}
          {bodyText}
          {referenceNumber&&<p>{this.btranslate('Your reference number is {reference}',referenceNumber)}.</p>}
          <p>
            {this.btranslateLink('If you want to start the registration process again, please click `here`.', '`', `/coachportal/register/${this.state.registerUUID}`, false)}
          </p>
        </>}
        {this.state.isPaymentComplete&&<>
          {this.btranslate('Dear {name} {surname}',name,surname)},<br></br><br></br>
          {this.btranslate('We are delighted to inform you that your purchase of an Aephoria Enneagram assessment in {language} has been successfully processed. The total amount paid for this assessment is {price}', 
            aserver.LanguageMap[assessmentLanguage], 
            this.btranslate(priceString, cost))}.<br></br><br></br>
          {this.btranslate('An invitation to complete your assessment has been emailed to you at {email}. Your reference number is {reference}.', email, referenceNumber)}<br></br><br></br>
          {this.btranslate('Should you have any queries or require further assistance, please do not hesitate to contact us at hello@aephoriagroup.com')}<br></br><br></br>
          {this.btranslate('Best regards,')}<br></br>
          Aephoria
        </>}
        </p>
      </div>
    }

    if (this.state.mode === modeRegister) {
      const { negegesigte, isFree, hideCoachBlurb } = this.state;
      if (!this.state.coachValid) {
        showBody = <>
            Invalid link. Please use the link exactly as provided to you by your coach, and contact your coach for a new link if it still doesn't work.
        </>
      } else if (this.state.freeRegistrationComplete) {
        showBody = <p>
          Thank you, {this.state.name}. Your registration is complete.<br/><br/>
          An invitation to complete your assessment has been emailed to you at {this.state.email}.<br/><br/>
          The results of your assessment will be emailed to you automatically on completion.<br/><br/>
          Should you have any queries or require further assistance, please do not hesitate to contact us at hello@aephoriagroup.com<br/><br/>
          Best regards,<br/>
          Aephoria
        </p>
      } else {
        showBody = <>
          {this.state.redirecting?<div>{this.btranslate('Please wait...')}</div>:
          <div style={{ display: this.state.proceeding ? "block" : "none" }}>
            <p>{this.state.message}</p>
            {/*//is this message still needed?
            <p style={{ margin: "0", display: this.state.message && this.state.currency === "USD" ? "block" : "none" }}>We are unable to process payments with Amex in USD.</p>
            */}
            <p>
            {this.state.showPayPalButtons&&<PayPal
              paypalCaptureUrl ={this.state.paypalCaptureUrl}
              payPalClientId={this.state.payPalClientId}
              payPalEnvironment={this.state.payPalEnvironment}
              onFailure={this.onPayPalFailure}
              onSuccess={this.onPayPalSuccess}
            />}
            </p>
          </div>}
          <div style={{ display: !this.state.proceeding ? "block" : "none" }}>
            <form name="PayFastPayNowForm" action={this.state.formAction} method="post">
              <input required type="hidden" name="cmd" value="_paynow" />
              <input required type="hidden" name="receiver" pattern="[0-9]" value={this.state.payFastMerchantId} />
              <input required type="hidden" name="payment_method" value="cc" />
              <input type="hidden" name="name_first" value={this.state.name} />
              <input type="hidden" name="name_last" value={this.state.surname} />
              <input type="hidden" name="return_url" value={this.state.return_url} />
              <input type="hidden" name="cancel_url" value={this.state.cancel_url} />
              <input type="hidden" name="notify_url" value={this.state.notify_url} />
              <input type="hidden" name="custom_str1" value={this.state.checkoutId} />
              <input type="hidden" name="email_address" value={this.state.email} />
              <input required type="hidden" name="amount" value={this.state.costOfAssessment} />
              <input required type="hidden" name="item_name" maxLength="255" value={pfItemName} />
              <input type="hidden" name="item_description" maxLength="255" value={pfItemDescription} />
            </form>
            <div>
              {negegesigte&&<div className="languageToggle" style={{ textAlign: "center", margin: "0 0 2vh" }}>
                <Button
                  variant={this.state.uiLanguage===afrikaans?"contained":"outlined"}
                  color="primary"
                  size="small"
                  onClick={() => this.setUILanguage(afrikaans)}
                  style={{ marginLeft: "8px" }}
                >
                  <span style={{color:this.state.uiLanguage===afrikaans?"white":"#00447D"}}>Afrikaans</span>
                </Button>
                <Button
                  variant={this.state.uiLanguage===english?"contained":"outlined"}
                  color="primary"
                  size="small"
                  onClick={() => this.setUILanguage(english)}
                >
                  <span style={{color:this.state.uiLanguage===afrikaans?"#00447D":"white"}}>English</span>
                </Button>
              </div>}              

              {negegesigte&&(this.state.uiLanguage===afrikaans?<><p>
              Welkom. Dankie dat jy hierdie stap neem. Ons is bly jy is hier.</p>
              <p>Deur hierdie Enneagram-assessering te voltooi, kies jy om jouself: jou patrone, jou dryfvere en jou ontwikkelings moontlikhede beter te leer ken. Dit is meer as net ’n assessering; dit is ’n volgende stap in jou reis na groter bewustheid en nuwe keuses.
              </p></>:<><p>
              Welcome. Thank you for taking this step. We are glad you are here.</p>
              <p>By completing this Enneagram assessment, you are choosing to get to know yourself better: your patterns, your drivers and your development possibilities. This is more than just an assessment; it is a next step in your journey towards greater awareness and new choices.
              </p></>)}                

              <h5 className="selfRegisterHeading" >{this.btranslate('Your Details')}</h5>
              <div className="input-wrapper-1 addClientDiv" >
                <input type="text" name="name" id="name" onChange={this.handleChange} value={this.state.name} autoFocus />
                <label className="edit">{this.btranslate('Name')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="surname" id="surname" onChange={this.handleChange} value={this.state.surname} />
                <label className="edit">{this.btranslate('Surname')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="email" id="email" onChange={this.handleChange} value={this.state.email} />
                <label className="edit">{this.btranslate('Email')}</label>
              </div>
            </div>
            <div>
              <h5 className="selfRegisterHeading">{this.btranslate('Assessment Details')}</h5>
              <div className="styled-select input-wrapper-1">
                <select id="dropdown" onChange={this.handleChange} style={{ textTransform: "capitalize" }} name="assessmentLanguage" value={this.state.assessmentLanguage} required>
                  {aserver.Languages.sort().map((info, i) => {
                    return (
                      <option key={i} value={info}>{info.charAt(0).toUpperCase() + info.slice(1)}</option>
                    )
                  })}
                </select>
                <label>{this.btranslate('Language')}</label>
              </div>
              <div className="input-wrapper-1 addClientDiv">
                <input type="text" name="assessmentType" id="assessmentType" disabled={true} style={{ color: "grey" }} value="Enneagram" />
                <label className="edit">{this.btranslate('Assessment')}</label>
              </div>
            </div>
            <div>
              {/* <h5 className="selfRegisterHeading">Terms and Conditions</h5> */}
              {negegesigte&&(this.state.uiLanguage===afrikaans?<>
              <p>Jou resultate en gepaardgaande verslae sal met die skrywers van <i>Kettings tot Keuses – Nege Gesigte van Menswees</i> en Enneagram-afrigtingspraktisyns, Jacques Engelbrecht en Sav Goldridge, gedeel word.</p>

              <p>Indien jy dit verkies, kan jy Sav en Jacques op <a href="mailto:info@negegesigte.co.za" target="_blank" rel="noreferrer">info@negegesigte.co.za</a> kontak om verder te gesels om jou resultate te verken en dit prakties toe te pas in jou persoonlike of professionele lewe. Ons sien uit daarna om hierdie pad saam met jou te stap.</p>

              {this.state.currency==='USD'?
              <p><b>Prys:</b> ${this.state.costOfAssessment} (USD) met n spesiale <i>Nege Gesigte</i> afslag (Normale prys is ${this.state.costOfAssessmentNormal})</p>:
              <p><b>Prys:</b> R{this.state.costOfAssessment} (BTW ingesluit) met n spesiale <i>Nege Gesigte</i> afslag (Normale prys is R{this.state.costOfAssessmentNormal})</p>}
              </>:<>
              <p>Your results and accompanying reports will be shared with the authors of <i>Chains to Choices - Nine Faces of Being Human</i> and Enneagram coaching practitioners, Savnola Goldridge and Jacques Engelbrecht.</p>

              <p>Should you prefer, you can contact Savnola and Jacques at <a href="mailto:info@chainstochoices.co.za" target="_blank" rel="noreferrer">info@chainstochoices.co.za</a> to discuss further, explore your results and apply them practically in your personal or professional life. We look forward to walking this path with you.</p>

              {this.state.currency==='USD'?
              <p><b>Price:</b> ${this.state.costOfAssessment} (USD) with a special <i>Chains to Choices</i> discount (Normal price is ${this.state.costOfAssessmentNormal})</p>:
              <p><b>Price:</b> R{this.state.costOfAssessment} (VAT included) with a special <i>Chains to Choices</i> discount (Normal price is R{this.state.costOfAssessmentNormal})</p>}
              </>)}
              {hideCoachBlurb&&<p>
                The results of your assessment will be emailed to you automatically on completion.
              </p>}
              {(!negegesigte && !hideCoachBlurb)&&<p>
                {this.btranslate('The results of your assessment and associated reports will be made available to {coachName}.', this.state.coachName)}
              </p>}
              {(!negegesigte && !isFree)&&<p>
                {this.btranslate('Price:')} <b>{this.btranslate(this.state.priceString, this.state.costOfAssessment)}</b>
              </p>}
              <p>
                {this.btranslateLink('By clicking on "Proceed", you agree to `our general terms.`', '`',"https://aephoriagroup.com/general-terms/",true)}
              </p>
            </div>
            <div className="registrationButton">
              <Button variant="contained" color="primary" type="submit" disabled={this.state.buttonClicked} onClick={() => this.proceedToPaymentGateway()}>
                {this.state.buttonClicked?
                this.btranslate('Please wait...'):
                this.btranslate('Proceed')}
              </Button>
            </div>
            <div style={{textAlign: "center"}}>
              <p>
                <small>Help: <a href="mailto:devteam@aephoriagroup.com" target="_blank" rel="noreferrer">devteam@aephoriagroup.com</a></small>
              </p>
            </div>
          </div>
        </>
      }
    }

    return (
      <main className="selfRegister" >
        <img className="registerFormLogo top-div" src={AephoriaLogo} alt="Aephoria Lab Logo" />
        <div className="selfregisterForm middle-div">
          <div className="selfRegisterFormContent">
            <h1 style={{ "textAlign": "center", "margin": "1vh" }}>{this.state.isFree ? 'Free Individual Enneagram Assessment Registration' : this.btranslate('Individual Enneagram Assessment Registration')}</h1>
            {showBody}
          </div>
        </div>
      </main>
    );
  }
}

export default SelfRegister
